import React from "react";

import { DetailGroupType } from "../../../../../models";
import ValueWithTitle from "./ValueWithTitle";
import ValueOnly from "./ValueOnly";
import TextArea from "./TextArea";
import styles from "./itemData.scss";

const ItemData = ({ data, type, lastLineItem, category, adId, hrPageName }) => {
  switch (type) {
    case DetailGroupType.valueOnly:
      return <ValueOnly itemData={data} />;

    case DetailGroupType.valueWithTitle:
      return (
        <ValueWithTitle
          itemData={data}
          className={lastLineItem ? styles.lastLine : ""}
        />
      );

    case DetailGroupType.textArea:
      return <TextArea itemData={data} category={category} adId={adId} hrPageName={hrPageName} />;

    default:
      return null;
  }
};

ItemData.defaultProps = { type: "" };

export default ItemData;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/ItemData.tsx